import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import { thousandSeparator } from "utils"
import classes from "./OfflineOrderDetailsItem.module.scss"

const OfflineOrderDetailsItem = props => {
  const { orderItem } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <div className={classes["left"]}>
        <LazyImage
          src={orderItem.foodImageCover}
          imageWidth={200}
          quality={80}
          className={clsx(
            classes["image"],
            isLtr && classes["image-ltr"]
          )}
        />

        <div
          className={clsx(
            classes["info"],
            isLtr && classes["info-ltr"]
          )}
        >
          <div className={classes["row"]}>
            <span>{t("کد_کالا")}:</span>
            <span
              className={clsx(
                classes["code"],
                isLtr && classes["code-ltr"]
              )}
            >
              {orderItem.code}
            </span>
          </div>

          <div className={classes["name"]}>
            {orderItem.foodName}
          </div>

          {
            !!orderItem.optionName &&
            <div className={classes["name"]}>
              {orderItem.optionName}
            </div>
          }

          <div className={classes["bold"]}>
            {thousandSeparator(orderItem.salePrice)}
            {" "}
            {orderItem.quantity}x
          </div>
        </div>
      </div>

      <div className={classes["price"]}>
        {thousandSeparator(orderItem.salePrice * orderItem.quantity)}
      </div>
    </div>
  )
}

export default OfflineOrderDetailsItem